import { Box } from '@mui/material';
import { ModalName } from 'app/enums';
import { ChatBox } from 'modules/chat/components/ChatBox';
import { ChatBoxContext, ChatSessionContext } from 'modules/chat/providers';
import React, { FC, useContext } from 'react';
import { Loader } from 'shared/components/Loader';
import { Modal } from 'shared/components/Modal';
import { withModalOpenChecker } from 'shared/HOC/withModalOpenChecker';

const ChatModalComponent: FC = () => {
  const { talkLoaded } = useContext(ChatSessionContext);
  const { conversation, isLoaded, resetChat } = useContext(ChatBoxContext);

  return (
    <Modal
      maxWidth="md"
      onClose={resetChat}
      contentHeight={630}
      name={ModalName.Chat}
      title="Private Message"
      disableEnforceFocus={true}
      isFooterHighlighted={false}
    >
      {(!talkLoaded || !isLoaded) && (
        <Box display="flex" height="100%" justifyContent="center">
          <Loader />
        </Box>
      )}
      {talkLoaded && isLoaded && <ChatBox conversationId={conversation} />}
    </Modal>
  );
};

export const ChatModal = withModalOpenChecker(ChatModalComponent, ModalName.Chat);
